import {Route, BrowserRouter as Router, Switch, withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import StyleSurveyAPI from "../modules/StyleSurveyAPI";
import StyleSurveyHelperClass from "../modules/StyleSurveyHelper";
import {checkProgress} from "../modules/checkProgress";
import {getExperimentVariants} from "../../../lib/optimizely/index.js";

let StyleSurveyHelper = null;

class StyleSurvey extends React.Component {
  static propTypes = {
    "actionName": PropTypes.string.isRequired,
    "apiToken": PropTypes.string,
    "customerId": PropTypes.number,
    "data": PropTypes.object.isRequired,
    "location": PropTypes.object.isRequired,
    "recaptchaScoreThreshold": PropTypes.string.isRequired,
    "recaptchaSiteKey": PropTypes.string.isRequired
  };

  static defaultProps = {
    "apiToken": null,
    "customerId": null
  };

  constructor (props) {
    super(props);

    const {apiToken, "data": {customer, survey}, "location": {pathname}} = this.props;

    this.experimentVariants = getExperimentVariants();
    StyleSurveyHelper = new StyleSurveyHelperClass(this.experimentVariants, RegExp("retake").test(pathname));

    StyleSurveyAPI.setApiToken(apiToken);
    StyleSurveyAPI.setSurveyId(survey);
    StyleSurveyHelperClass.camelizeSurvey(survey);
    if (!survey.rings) {
      StyleSurveyHelper.removeRingSizeQuestion();
    }

    this.state = {
      customer,
      survey
    };

    checkProgress();
  }

  // This is a simpler, more extensible version of `handleAnswer`
  patchSurvey = (newParams) => {
    this.setState(
      (prevState) => {
        const {survey} = prevState;
        if (newParams.rings === true) {
          StyleSurveyHelper.addRingSizeQuestion();
        // Don't change anything if undefined...
        } else if (newParams.rings === false) {
          StyleSurveyHelper.removeRingSizeQuestion();
        }
        return {
          "survey": {
            ...survey,
            ...newParams
          }
        };
      },
      () => {
        const {customerId} = this.props;
        StyleSurveyAPI.updateSurvey(customerId, StyleSurveyHelperClass.snakeizeSurvey(newParams));
      }
    );
  }

  handleAnswer = (answer, shouldToggle) => {
    const apiAnswer = {};
    this.setState((prevState) => {
      const {survey} = prevState;
      Object.keys(answer).forEach((key) => {
        const value = shouldToggle
          ? !answer[key]
          : answer[key];
        survey[key] = value;
        apiAnswer[key] = value;
      });
      const ringsArr = Object.keys(survey).filter(item => item.indexOf("ring") === 0); // eslint-disable-line one-var
      const filtered = ringsArr.filter(ring => survey[ring]); // eslint-disable-line sort-vars

      if (filtered.length === 0) survey.rings = false;
      else {
        filtered.length > 1 || filtered[0] !== "rings" ? survey.rings = true : survey.rings = false;
      }
      survey.rings ? StyleSurveyHelper.addRingSizeQuestion() : StyleSurveyHelper.removeRingSizeQuestion();
      return {survey};
    }, () => {
      const {customerId} = this.props;
      StyleSurveyAPI.updateSurvey(customerId, StyleSurveyHelperClass.snakeizeSurvey(apiAnswer));
    });
  };

  showNextQuestion = (event) => {
    const {customer, survey} = this.state;
    const {handleAnswer, patchSurvey, setBirthday} = this;
    const {
      "match": {"params": {endpoint, path}},
      location
    } = event;
    const {recaptchaScoreThreshold, recaptchaSiteKey} = this.props;
    const questionData = StyleSurveyHelper.getQuestionData(endpoint, path, survey);
    const questionHeader = StyleSurveyHelper.getQuestionHeader(path, handleAnswer);
    const {surveyFields} = questionData;
    const surveyValues = Object.keys(surveyFields).map(field => survey[field]);

    return React.createElement(
      questionData.component, {
        "answers": questionData.answers,
        customer,
        "header": questionHeader,
        location,
        "multiSelect": questionData.multiSelect,
        "nextRoute": questionData.nextQuestion,
        "onAnswer": handleAnswer,
        patchSurvey,
        "prevRoute": questionData.prevQuestion,
        recaptchaScoreThreshold,
        recaptchaSiteKey,
        setBirthday,
        "skip": questionData.skip,
        surveyFields,
        surveyValues
      }
    );
  };

  setBirthday = (birthday) => {
    this.setState((prevState) => {
      const {customer} = prevState;
      customer.birthday = birthday;
      return {customer};
    });
  };

  signupRedirect = (event) => {
    const {customerId} = this.props;

    if (customerId) {
      const {history, "match": {"params": {endpoint}}} = event;
      history.replace(`/${endpoint}/finish`);
      return null;
    }

    event.match.params.path = "signup";
    return this.showNextQuestion(event);
  };

  render () {
    const classNames = `${window.experimentVariants} style-survey-component`;
    return (
      <div className={classNames}>
        <Router basename="/surveys">
          <Switch>
            <Route
              exact
              path="/:endpoint"
              render={this.showNextQuestion}
            />
            <Route
              exact
              key="/:endpoint/signup"
              path="/:endpoint/signup"
              render={this.signupRedirect}
            />
            <Route
              path="/:endpoint/:path"
              render={this.showNextQuestion}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default withRouter(StyleSurvey);
